import React from 'react';
import PropTypes from 'prop-types';

const VideoHero = ({ file, iphone_backup_video_file }) => {
  // Check if the user agent is an iPhone
  const isIphone = /iPhone/i.test(navigator.userAgent);

  // Choose the appropriate file based on the user agent
  const videoFile = isIphone ? iphone_backup_video_file : file;

  if (!videoFile) {
    return null;
  }

  // Get suffix from file for mime
  const suffix = videoFile.split('.').pop();

  return (
    <div className="videohero">
      <div id="videohero">
        <video
          playsInline
          autoPlay
          muted
          loop
          id="herovideo"
          width="x"
          height="y"
        >
          <source src={videoFile} type={`video/${suffix}`} />
        </video>
      </div>
    </div>
  );
};

VideoHero.propTypes = {
  file: PropTypes.string.isRequired,
  iphone_backup_video_file: PropTypes.string.isRequired,
};

export default VideoHero;
